export const PAYMENT_GATEWAY_API_BASE_URL: string = window.tpConfig?.PAYMENT_GATEWAY_API_BASE_URL ?? "";
export const TP_API_BASE_URL: string = window.tpConfig?.TP_API_BASE_URL ?? "";
export const STRIPE_CHECKOUT_BASE_URL: string = window.tpConfig?.STRIPE_CHECKOUT_BASE_URL ?? "";
export const ZUORA_CHECKOUT_BASE_URL: string = window.tpConfig?.ZUORA_CHECKOUT_BASE_URL ?? "";
export const HOME_BASE_URL: string = window.tpConfig?.HOME_BASE_URL ?? "";
export const APP_BASE_URL: string = window.tpConfig?.APP_BASE_URL ?? "";
export const ZUORA_PUBLISHABLE_KEY: string = window.tpConfig?.ZUORA_PUBLISHABLE_KEY ?? "";
export const ZUORA_SDK_URL: string = window.tpConfig?.ZUORA_SDK_URL ?? "";
export const ROLLBAR_CLIENT_TOKEN: string = window.tpConfig?.ROLLBAR_CLIENT_TOKEN ?? "";
export const ROLLBAR_ENVIRONMENT: string = window.tpConfig?.ROLLBAR_ENVIRONMENT ?? "local";
export const CODE_VERSION: string = window.tpConfig?.CODE_VERSION ?? "";
export const GOOGLE_MEASUREMENT_ID: string = window.tpConfig?.GOOGLE_MEASUREMENT_ID ?? "";
export const USEREVENTS_BASE_URL: string = window.tpConfig?.USEREVENTS_BASE_URL ?? "";
